import CampusPage from './CampusPage';
import { CAMPUS_DATA } from '../../data/campus';

export default function MasCoyoacan() {
  return <CampusPage campus={CAMPUS_DATA.coyoacan} />;
}
